
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import React, { useEffect } from "react";
import allowNumbersOnly, { handlePaste } from "../../CommonUtils/CommonValidations";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import * as Yup from 'yup'
import * as bie from "react-bootstrap";
import Swal from "sweetalert2";
import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
import { ERROR_MSG } from "../../CommonUtils/contextVariables";
import { useSelector } from "react-redux";
import CommonFormHeading from "../../CommonUtils/CommonFormHeading";
export default function AfflAdministrativeAreasForm() {
  const Collegetype = useSelector((state) => state?.commonMastersReducer?.CollegeType);

  const validationSchema = Yup.object().shape({
    chairSecyRooms: Yup.number().required(ERROR_MSG).nullable(),
    chairSecyArea: Yup.number().required(ERROR_MSG).nullable(),
    principalRooms: Yup.number().required(ERROR_MSG).nullable(),
    principalArea: Yup.number().required(ERROR_MSG).nullable(),
    boardRooms: Yup.number().required(ERROR_MSG).nullable(),
    boardArea: Yup.number().required(ERROR_MSG).nullable(),
    officeRooms: Yup.number().required(ERROR_MSG).nullable(),
    officeArea: Yup.number().required(ERROR_MSG).nullable(),
    departmentRooms: Yup.number().required(ERROR_MSG).nullable(),
    departmentArea: Yup.number().required(ERROR_MSG).nullable(),
    headDepartmentRooms: Yup.number().required(ERROR_MSG).nullable(),
    headDepartmentArea: Yup.number().required(ERROR_MSG).nullable(),
    facultyRooms: Yup.number().required(ERROR_MSG).nullable(),
    facultyArea: Yup.number().required(ERROR_MSG).nullable(),
    centralStoresRooms: Yup.number().required(ERROR_MSG).nullable(),
    centralStoresArea: Yup.number().required(ERROR_MSG).nullable(),
    maintenanceRooms: Yup.number().required(ERROR_MSG).nullable(),
    maintenanceArea: Yup.number().required(ERROR_MSG).nullable(),
    securityRooms: Yup.number().required(ERROR_MSG).nullable(),
    securityArea: Yup.number().required(ERROR_MSG).nullable(),
    houseKeepingRooms: Yup.number().required(ERROR_MSG).nullable(),
    houseKeepingArea: Yup.number().required(ERROR_MSG).nullable(),
    pantryRooms: Yup.number().required(ERROR_MSG).nullable(),
    pantryArea: Yup.number().required(ERROR_MSG).nullable(),
    examinationRooms: Yup.number().required(ERROR_MSG).nullable(),
    examinationArea: Yup.number().required(ERROR_MSG).nullable(),
    placementRooms: Yup.number().required(ERROR_MSG).nullable(),
    placementArea: Yup.number().required(ERROR_MSG).nullable(),
    iqacRooms: Yup.number().required(ERROR_MSG).nullable(),
    iqacArea: Yup.number().required(ERROR_MSG).nullable()
  });
  const AdminAreaformik = useFormik({
    enableReinitialize: true,
    initialValues: {
      "principalRooms": "",
      "principalArea": "",
      "boardRooms": "",
      "boardArea": "",
      "officeRooms": "",
      "officeArea": "",
      "departmentRooms": "",
      "departmentArea": "",
      "headDepartmentRooms": "",
      "headDepartmentArea": "",
      "facultyRooms": "",
      "facultyArea": "",
      "centralStoresRooms": "",
      "centralStoresArea": "",
      "maintenanceRooms": "",
      "maintenanceArea": "",
      "securityRooms": "",
      "securityArea": "",
      "houseKeepingRooms": "",
      "houseKeepingArea": "",
      "pantryRooms": "",
      "pantryArea": "",
      "examinationRooms": "",
      "examinationArea": "",
      "placementRooms": "",
      "placementArea": "",
      "iqacRooms": "",
      "iqacArea": "",
      "chairSecyRooms": "",
      "chairSecyArea": ""
    },
    validationSchema: validationSchema,
    onSubmit: (val) => {
      Swal.fire({
        text: 'Are you sure you want to submit?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, submit it!',
        cancelButtonText: 'No, cancel!',
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          let url = config.url.API_URL + `saveAfflAdministrativeArea`
          CommonAxiosPost(url, val).then((res) => {
            if (res?.data?.scode === '01') {
              successAlert2(res?.data?.sdesc);
              getDetails();


            }
            else {
              failureAlert("Failed to submit")

            }
          })
        }
      })
    }
  })
  function getDetails() {
    let url = config.url.API_URL + `getAfflAdministrativeAreaReport`
    CommonAxiosGet(url).then(res => {
      if (res?.data?.scode === "01") {
        AdminAreaformik.setFieldValue("chairSecyRooms", res?.data?.AfflAdministrativeAreaReport[0]?.chair_secy_rooms);
        AdminAreaformik.setFieldValue("chairSecyArea", res?.data?.AfflAdministrativeAreaReport[0]?.chair_secy_area);
        AdminAreaformik.setFieldValue("principalRooms", res?.data?.AfflAdministrativeAreaReport[0]?.principal_rooms);
        AdminAreaformik.setFieldValue("principalArea", res?.data?.AfflAdministrativeAreaReport[0]?.principal_area);
        AdminAreaformik.setFieldValue("boardRooms", res?.data?.AfflAdministrativeAreaReport[0]?.board_rooms);
        AdminAreaformik.setFieldValue("boardArea", res?.data?.AfflAdministrativeAreaReport[0]?.board_area);
        AdminAreaformik.setFieldValue("officeRooms", res?.data?.AfflAdministrativeAreaReport[0]?.office_rooms);
        AdminAreaformik.setFieldValue("officeArea", res?.data?.AfflAdministrativeAreaReport[0]?.office_area);
        AdminAreaformik.setFieldValue("departmentRooms", res?.data?.AfflAdministrativeAreaReport[0]?.department_rooms);
        AdminAreaformik.setFieldValue("departmentArea", res?.data?.AfflAdministrativeAreaReport[0]?.department_area);
        AdminAreaformik.setFieldValue("headDepartmentRooms", res?.data?.AfflAdministrativeAreaReport[0]?.head_department_rooms);
        AdminAreaformik.setFieldValue("headDepartmentArea", res?.data?.AfflAdministrativeAreaReport[0]?.head_department_area);
        AdminAreaformik.setFieldValue("facultyRooms", res?.data?.AfflAdministrativeAreaReport[0]?.faculty_rooms);
        AdminAreaformik.setFieldValue("facultyArea", res?.data?.AfflAdministrativeAreaReport[0]?.faculty_area);
        AdminAreaformik.setFieldValue("centralStoresRooms", res?.data?.AfflAdministrativeAreaReport[0]?.central_stores_rooms);
        AdminAreaformik.setFieldValue("centralStoresArea", res?.data?.AfflAdministrativeAreaReport[0]?.central_stores_area);
        AdminAreaformik.setFieldValue("maintenanceRooms", res?.data?.AfflAdministrativeAreaReport[0]?.maintenance_rooms);
        AdminAreaformik.setFieldValue("maintenanceArea", res?.data?.AfflAdministrativeAreaReport[0]?.maintenance_area);
        AdminAreaformik.setFieldValue("securityRooms", res?.data?.AfflAdministrativeAreaReport[0]?.security_rooms);
        AdminAreaformik.setFieldValue("securityArea", res?.data?.AfflAdministrativeAreaReport[0]?.security_area);
        AdminAreaformik.setFieldValue("houseKeepingRooms", res?.data?.AfflAdministrativeAreaReport[0]?.house_keeping_rooms);
        AdminAreaformik.setFieldValue("houseKeepingArea", res?.data?.AfflAdministrativeAreaReport[0]?.house_keeping_area);
        AdminAreaformik.setFieldValue("pantryRooms", res?.data?.AfflAdministrativeAreaReport[0]?.pantry_rooms);
        AdminAreaformik.setFieldValue("pantryArea", res?.data?.AfflAdministrativeAreaReport[0]?.pantry_area);
        AdminAreaformik.setFieldValue("examinationRooms", res?.data?.AfflAdministrativeAreaReport[0]?.examination_rooms);
        AdminAreaformik.setFieldValue("examinationArea", res?.data?.AfflAdministrativeAreaReport[0]?.examination_area);
        AdminAreaformik.setFieldValue("placementRooms", res?.data?.AfflAdministrativeAreaReport[0]?.placement_rooms);
        AdminAreaformik.setFieldValue("placementArea", res?.data?.AfflAdministrativeAreaReport[0]?.placement_area);
        AdminAreaformik.setFieldValue("iqacRooms", res?.data?.AfflAdministrativeAreaReport[0]?.iqac_rooms);
        AdminAreaformik.setFieldValue("iqacArea", res?.data?.AfflAdministrativeAreaReport[0]?.iqac_area);
      }
    });
  }
  useEffect(() => {
    getDetails();
  }, []);
  return (
    <>
      <bie.Container fluid className="px-1" >
        <CommonFormHeading heading={"Administrative Area"} />

        {/* <bie.Row>
          <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11} className="">
            <div className="inner-herbpage-service-title1">
              <h1>Administrative Area</h1>
            </div>
          </bie.Col>
          <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className='mb-2'>
            <button className="breadcrumb-item"><a href="/dashboard" className='affl-dash'><FaHome size={30} /></a></button>
          </bie.Col>
        </bie.Row> */}
        <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5" >
          <center>
            <div className="inner-herbpage-service-title-sub"  >
              <h1 className="">Administrative Area Details</h1>
            </div>
            <FormikProvider value={AdminAreaformik}>
              <Form onChange={AdminAreaformik.handleChange} onSubmit={AdminAreaformik.handleSubmit} className="affl-form" >
                <div className="table-responsive">
                  <table className="table table-condensed table-bordered table-sm table-responsive affl-table" >
                    <thead>
                      <tr className="affl-thead">
                        <th>Particulars</th>
                        <th>No of Rooms</th>
                        <th>Total Area ({Collegetype})</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "left", color: "black" }}>Chairperson/Secretary Room</td>
                        <td><Field type="text" maxLength="3" className="form-control" name="chairSecyRooms" placeholder="No of rooms" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} ></Field>

                          <ErrorMessage name="chairSecyRooms" component="div" className="text-error" /></td>
                        <td><Field type="text" maxLength="5" className="form-control" name="chairSecyArea" placeholder="Total Area" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}
                        />
                          <ErrorMessage name="chairSecyArea" component="div" className="text-error" /></td>
                      </tr>
                      <tr>
                        <td style={{ textAlign: "left", color: "black" }}>Principal Room</td>
                        <td><Field type="text" maxLength="3" className="form-control" name="principalRooms" placeholder="No of rooms" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="principalRooms" component="div" className="text-error" /></td>
                        <td><Field type="text" maxLength="5" className="form-control" name="principalArea" placeholder="Total Area" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field><ErrorMessage name="principalArea" component="div" className="text-error" /></td>
                      </tr>
                      <tr><td style={{ textAlign: "left", color: "black" }}>Board Room</td>
                        <td><Field type="text" maxLength="3" className="form-control" name="boardRooms" placeholder="No of rooms" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="boardRooms" component="div" className="text-error" /></td>
                        <td><Field type="text" maxLength="5" className="form-control" name="boardArea" placeholder="Total Area" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="boardArea" component="div" className="text-error" /></td>
                      </tr>
                      <tr><td style={{ textAlign: "left", color: "black" }}>Office Room</td>
                        <td><Field type="text" maxLength="3" className="form-control" name="officeRooms" placeholder="No of rooms" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field><ErrorMessage name="officeRooms" component="div" className="text-error" /></td>
                        <td><Field type="text" maxLength="5" className="form-control" name="officeArea" placeholder="Total Area" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field><ErrorMessage name="officeArea" component="div" className="text-error" /></td>
                      </tr>
                      <tr><td style={{ textAlign: "left", color: "black" }}>Department Office</td>
                        <td><Field type="text" maxLength="3" className="form-control" name="departmentRooms" placeholder="No of rooms" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field><ErrorMessage name="departmentRooms" component="div" className="text-error" /></td>
                        <td><Field type="text" maxLength="5" className="form-control" name="departmentArea" placeholder="Total Area" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field><ErrorMessage name="departmentArea" component="div" className="text-error" /></td>
                      </tr>
                      <tr><td style={{ textAlign: "left", color: "black" }}>Head of Department</td>
                        <td><Field type="text" maxLength="3" className="form-control" name="headDepartmentRooms" placeholder="No of rooms" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="headDepartmentRooms" component="div" className="text-error" /></td>
                        <td><Field type="text" maxLength="5" className="form-control" name="headDepartmentArea" placeholder="Total Area" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} ></Field>
                          <ErrorMessage name="departmentArea" component="div" className="text-error" /></td>
                      </tr>
                      <tr><td style={{ textAlign: "left", color: "black" }}> Faculty Rooms</td>
                        <td><Field type="text" maxLength="3" className="form-control" name="facultyRooms" placeholder="No of rooms" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="facultyRooms" component="div" className="text-error" /></td>
                        <td><Field type="text" maxLength="5" className="form-control" name="facultyArea" placeholder="Total Area" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="facultyArea" component="div" className="text-error" /></td>
                      </tr>
                      <tr><td style={{ textAlign: "left", color: "black" }}>Central Stores</td>
                        <td><Field type="text" maxLength="3" className="form-control" name="centralStoresRooms" placeholder="No of rooms" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="centralStoresRooms" component="div" className="text-error" /></td>
                        <td><Field type="text" maxLength="5" className="form-control" name="centralStoresArea" placeholder="Total Area" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="centralStoresArea" component="div" className="text-error" /></td>
                      </tr>
                      <tr><td style={{ textAlign: "left", color: "black" }}>Maintenance</td>
                        <td><Field type="text" maxLength="3" className="form-control" name="maintenanceRooms" placeholder="No of rooms" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="maintenanceRooms" component="div" className="text-error" /></td>
                        <td><Field type="text" maxLength="5" className="form-control" name="maintenanceArea" placeholder="Total Area" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="maintenanceArea" component="div" className="text-error" /></td>
                      </tr>
                      <tr><td style={{ textAlign: "left", color: "black" }}>Security</td>
                        <td><Field type="text" maxLength="3" className="form-control" name="securityRooms" placeholder="No of rooms" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="securityRooms" component="div" className="text-error" /></td>
                        <td><Field type="text" maxLength="5" className="form-control" name="securityArea" placeholder="Total Area" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="securityArea" component="div" className="text-error" /></td>
                      </tr>
                      <tr><td style={{ textAlign: "left", color: "black" }}>House Keeping</td>
                        <td><Field type="text" maxLength="3" className="form-control" name="houseKeepingRooms" placeholder="No of rooms" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="houseKeepingRooms" component="div" className="text-error" /></td>
                        <td><Field type="text" maxLength="5" className="form-control" name="houseKeepingArea" placeholder="Total Area" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="houseKeepingArea" component="div" className="text-error" /></td>
                      </tr>
                      <tr><td style={{ textAlign: "left", color: "black" }}> Pantry</td>
                        <td><Field type="text" maxLength="3" className="form-control" name="pantryRooms" placeholder="No of rooms" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field><ErrorMessage name="pantryRooms" component="div" className="text-error" /></td>
                        <td><Field type="text" maxLength="5" className="form-control" name="pantryArea" placeholder="Total Area" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field><ErrorMessage name="pantryArea" component="div" className="text-error" /></td>
                      </tr>
                      <tr><td style={{ textAlign: "left", color: "black" }}> Examination Control Office</td>
                        <td><Field type="text" maxLength="3" className="form-control" name="examinationRooms" placeholder="No of rooms" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field><ErrorMessage name="examinationRooms" component="div" className="text-error" /></td>
                        <td><Field type="text" maxLength="5" className="form-control" name="examinationArea" placeholder="Total Area" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field><ErrorMessage name="examinationArea" component="div" className="text-error" /></td>
                      </tr>
                      <tr><td style={{ textAlign: "left", color: "black" }}> Placement Office</td>
                        <td><Field type="text" maxLength="3" className="form-control" name="placementRooms" placeholder="No of rooms" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field><ErrorMessage name="placementRooms" component="div" className="text-error" /></td>
                        <td><Field type="text" maxLength="5" className="form-control" name="placementArea" placeholder="Total Area" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field><ErrorMessage name="placementArea" component="div" className="text-error" /></td>
                      </tr>
                      <tr><td style={{ textAlign: "left", color: "black" }}> IQAC Room</td>
                        <td><Field type="text" maxLength="3" className="form-control" name="iqacRooms" placeholder="No of rooms" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="iqacRooms" component="div" className="text-error" /></td>
                        <td><Field type="text" maxLength="5" className="form-control" name="iqacArea" placeholder="Total Area" onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)}></Field>
                          <ErrorMessage name="iqacArea" component="div" className="text-error" /></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="pt-1 mb-5">

                  <button type="submit" className="btn btn-success btn-sm float-end" >
                    Submit
                  </button>

                </div>
              </Form></FormikProvider> </center></bie.Container>
      </bie.Container></>
  )
}